import './index.scss'
import '../../assets/scripts/jquery.validate.min.js';

$(document).ready(function(){
  var langtext = $(".language .lan-title span").text();
  if(langtext == 'EN'){
    $("#pro_form").validate();
  }
})